/*!

All API path using in the application
*/


const liveApiEndPoint = process.env.REACT_APP_API_ENDPOINT;

export const apiPath = {
  basePath: `${liveApiEndPoint}`,
  basePathFull: process.env.REACT_APP_BASE_PATH_FULL,
  login: `${liveApiEndPoint}/api/auth/login`,
  getFacilities: `${liveApiEndPoint}/services/admin/api/facilities`,
  forgotPassword: `${liveApiEndPoint}/services/maxauth/api/account/reset-password/init`,
  resetPassword: `${liveApiEndPoint}/services/maxauth/api/account/reset-password/finish`,
  fetchProfile: `${liveApiEndPoint}/services/maxauth/api/account`,
  profileAccount: `${liveApiEndPoint}/services/maxauth/api/account`,
  postProfile: `${liveApiEndPoint}/services/admin/api/account`,
  profileChangePassword: `${liveApiEndPoint}/services/maxauth/api/account/change-password`,
  consentDocuments: `${liveApiEndPoint}/services/admin/api/consent-documents`,
  getDischargePlanners: `${liveApiEndPoint}/services/admin/api/discharge-planner`,
  facilityAdminUsers: `${liveApiEndPoint}/services/admin/api/facility-admin/users`,
  facilityAdminFacilities: `${liveApiEndPoint}/services/admin/api/facility-admin/facilities`,
  // B2B org-admin
  meContext: `${liveApiEndPoint}/services/admin/api/me/context`,
  orgAdminFacilities: `${liveApiEndPoint}/services/admin/api/org-admin/facilities`,
  orgAdminReport: `${liveApiEndPoint}/services/admin/api/org-admin/report`,
  orgAdminMyGroupTree: `${liveApiEndPoint}/services/admin/api/org-admin/my-group-tree`,
  orgAdminFacilityUsers: `${liveApiEndPoint}/services/admin/api/org-admin/facility-users`,
  orgAdminGroups: `${liveApiEndPoint}/services/admin/api/org-admin/groups`,
  organizations: `${liveApiEndPoint}/services/admin/api/organizations`,
  // Organization group hierarchy (Region Groups + Managers)
  groups: `${liveApiEndPoint}/services/admin/api/groups`,
  facilitiesList: `${liveApiEndPoint}/services/admin/api/facilities`,
  getProviders: `${liveApiEndPoint}/services/admin/api/provider`,
  bulkUploadProviders: `${liveApiEndPoint}/services/admin/api/provider/bulk-upload-providers`,
  cmsProvidersBulkInsert: `${liveApiEndPoint}/services/admin/api/cms-providers/bulk-insert`,
  cmsProvidersBulkDelete: `${liveApiEndPoint}/services/admin/api/cms-providers/bulk-delete`,
  getProvidersFilter: `${liveApiEndPoint}/services/admin/api/providerFilter`,
  logoutApi: `${liveApiEndPoint}/api/auth/logout`,
  twoFaSendOtp: `${liveApiEndPoint}/api/auth/2fa/send-otp`,
  twoFaVerifyOtp: `${liveApiEndPoint}/api/auth/2fa/verify-otp`,
  twoFaUpdatePhone: `${liveApiEndPoint}/api/auth/2fa/update-phone`,
  revokeApi: `${liveApiEndPoint}/services/externalpatients/api/three-leeged-revok`,

  // imported patients apis
  pccPatientsUpdate: `${liveApiEndPoint}/services/externalpatients/api/pcc-patients-autoupdate`,
  getApiPartnerList: `${liveApiEndPoint}/services/externalpatients/api/api-partner-list`,
  importPatientList: `${liveApiEndPoint}/services/externalpatients/api/pcc-patients`,
  assignedPatientList: `${liveApiEndPoint}/services/externalpatients/api/pcc-assigned-patients`,
  assignPatientToDash: `${liveApiEndPoint}/services/externalpatients/api/assign-pcc-patients`,
  unassignPatientToDash: `${liveApiEndPoint}/services/externalpatients/api/do-unassign-pcc-patients`,
  GetPccPatientContacts: `${liveApiEndPoint}/services/externalpatients/api/getPccPatientContacts`,
  GetImportPccPatientContacts: `${liveApiEndPoint}/services/externalpatients/api/importPccPatientContacts`,

  
  // push note
  getNoteType: `${liveApiEndPoint}/services/externalpatients/api/note-type-get`,
  pushNote: `${liveApiEndPoint}/services/externalpatients/api/push-notes-to-pcc`,
  get3LeggedValues: `${liveApiEndPoint}/services/externalpatients/api/three-leeged-require-value`,
  auth3LeggedLogin: `https://connect.pointclickcare.com/auth/login?`,
  auth3LeggedGetToken: `https://connect.pointclickcare.com/auth/token`,
  post3LeggedApi: `${liveApiEndPoint}/services/externalpatients/api/three-leeged-get-accesstoken`,

  // provider profile cate
  getProviderProfileCategory: `${liveApiEndPoint}/services/admin/api/provider-category-list`,
  getProviderSubscription: `${liveApiEndPoint}/services/admin/api/provider-subscription`,
  saveProviderProfileCategory: `${liveApiEndPoint}/services/admin/api/provider-category-admin`,

  // providerFacilityHospital: `${liveApiEndPoint}/services/admin/api/provider-facility-hospital`,
  providerFacilityHospital: `${liveApiEndPoint}/services/provider/api/provider-facility-hospital`,
  getActiveFacilities: `${liveApiEndPoint}/services/admin/api/active-facilities`,
  assignableFacilities: `${liveApiEndPoint}/services/admin/api/facilities/assignable`,
  getProviderUsers: `${liveApiEndPoint}/services/admin/api/provideruser`,
  getActiveProviders: `${liveApiEndPoint}/services/admin/api/active-provider`,
  getCategory: `${liveApiEndPoint}/services/admin/api/categories`,
  getInsurance: `${liveApiEndPoint}/services/admin/api/insuranceList`,
  getHospitalList: `${liveApiEndPoint}/services/admin/api/previousHospitalList`,
  getPatientStatus: `${liveApiEndPoint}/services/admin/api/patientStatus`,
  getPatientLanNIns: `${liveApiEndPoint}/services/admin/api/languages-insurance`,



  getPatientList: `${liveApiEndPoint}/services/admin/api/patient`,
  createPatient: `${liveApiEndPoint}/services/admin/api/patient`,
  updatePatient: `${liveApiEndPoint}/services/admin/api/patient`,
  updateEstimatedDischargeDate: `${liveApiEndPoint}/services/admin/api/patient`, // PUT /{id}/estimated-discharge-date?date=YYYY-MM-DD
  uploadPatientFiles: `${liveApiEndPoint}/services/admin/api/uploadFileMultipart`,
  uploadPatientFiles1: `${liveApiEndPoint}/services/admin/api/uploadFileMultipart1`,
  getPatientInfo: `${liveApiEndPoint}/services/admin/api/patient`,
  changePatientStatus: `${liveApiEndPoint}/services/dischargeplanner/api/patient-status`,
  deleteFaceSheeet: `${liveApiEndPoint}/services/admin/api/face-sheet`,
  providerDataUse: `${liveApiEndPoint}/services/admin/api/provider-data-usage`,
  referralReportDownload: `${liveApiEndPoint}/services/admin/api/download-admin-referral-reports`,
  referralReportDownloadDp: `${liveApiEndPoint}/services/dischargeplanner/api/download-dp-referral-reports`,
  providerEngagementReport: `${liveApiEndPoint}/services/admin/api/provider-engagement-report`,
  providerEngagementReportDownload: `${liveApiEndPoint}/services/admin/api/provider-engagement-report/download`,
  getProviderInvoices: `${liveApiEndPoint}/services/admin/api/provider-invoices`,
  getProviderInvoicesByProviderId: `${liveApiEndPoint}/services/admin/api/provider-invoices-list`,

  providerCategory: `${liveApiEndPoint}/services/provider/api/provider-category`,
  findProvider: `${liveApiEndPoint}/services/provider/api/search`,

  sponsoredMetricsImpression: `${liveApiEndPoint}/services/admin/api/sponsored-metrics/impressions`,
  sponsoredMetricsClick: `${liveApiEndPoint}/services/admin/api/sponsored-metrics/click`,
  sponsoredMetricsReport: `${liveApiEndPoint}/services/admin/api/sponsored-metrics/report`,
  sponsoredMetricsReportDownload: `${liveApiEndPoint}/services/admin/api/sponsored-metrics/report/download`,

  // organization report (demo / future Organization hierarchy)
  organizationReport: `${liveApiEndPoint}/services/admin/api/organization-report`,

  awaitProvider: `${liveApiEndPoint}/services/provider/api/awaitSearch`,

  patientSearchHistory: `${liveApiEndPoint}/services/dischargeplanner/api/patient-search-history`,
  providerCriteria: `${liveApiEndPoint}/services/provider/api/provider-lan-insurance`,
  findAwaitingProvider: `${liveApiEndPoint}/services/dischargeplanner/api/sendrefferallist`,
  sendReferral: `${liveApiEndPoint}/services/dischargeplanner/api/sendrefferal`,
  updateReferral: `${liveApiEndPoint}/services/dischargeplanner/api/updateSendreferal`,
  sendProviderDetail: `${liveApiEndPoint}/services/dischargeplanner/api/sendmail`,
  changeProviderStatus: `${liveApiEndPoint}/services/dischargeplanner/api/update-ref-provider-status`,
  providerReferralList: `${liveApiEndPoint}/services/provider/api/referral-list`,
  getReferralDetail: `${liveApiEndPoint}/services/provider/api/referral-one`,
  rescindReferralDp: `${liveApiEndPoint}/services/dischargeplanner/api/resicnd-referrel`,
  providerAcceptReferral: `${liveApiEndPoint}/services/provider/api/referral-accepted`,
  providerDeclineReferral: `${liveApiEndPoint}/services/provider/api/referral-declined`,
  providerCanAcceptReferral: `${liveApiEndPoint}/services/provider/api/referral-can-accept`,
  providerMarkReferralViewed: `${liveApiEndPoint}/services/provider/api/referral-viewed`,
  notificationList: `${liveApiEndPoint}/services/provider/api/notification-list`,
  removeReferralFromDashboard: `${liveApiEndPoint}/services/provider/api/remove-refferal-dashboard`,
  isNewNotification: `${liveApiEndPoint}/services/provider/api/is-new-notification`,
  readNotification: `${liveApiEndPoint}/services/provider/api/notification-update`,
  patientStatusDelete: `${liveApiEndPoint}/services/dischargeplanner/api/patient-status`,
  getPatientAddress: `${liveApiEndPoint}/services/dischargeplanner/api/planner-address`,
  providerPageStageList: `${liveApiEndPoint}/services/provider/api/provider-profile-status`,
  getProviderOtherAddressList: `${liveApiEndPoint}/services/provider/api/other-locations`,
  getProviderFilterList: `${liveApiEndPoint}/services/provider/api/provider-referral-filter-list`,

  // tasks
  patientTasks: `${liveApiEndPoint}/services/dischargeplanner/api/patient-task`,
  patientTasksBulk: `${liveApiEndPoint}/services/dischargeplanner/api/list-patient-task`,
  patientTasksList: `${liveApiEndPoint}/services/dischargeplanner/api/patient-task/patient`,

  postCommentByDP: `${liveApiEndPoint}/services/dischargeplanner/api/referral-comment`,
  getCommentToDP: `${liveApiEndPoint}/services/dischargeplanner/api/referral-comment`,
  getPatientTasks: `${liveApiEndPoint}/services/dischargeplanner/api/patient-task/patient`,
  postPrelimComment: `${liveApiEndPoint}/services/provider/api/prelim-comment`,

  patientFilters: `${liveApiEndPoint}/services/admin/api/patient-filter`,
  providerStatus: `${liveApiEndPoint}/services/admin/api/status-bar`,

  providerSaveCard: `${liveApiEndPoint}/services/provider/api/save-card`,
  providerSavedCard: `${liveApiEndPoint}/services/provider/api/saved-card`,
  providerCategoryUpdate: `${liveApiEndPoint}/services/provider/api/subscription`,
  providerSaveCardAndCategoryUpdate: `${liveApiEndPoint}/services/provider/api/save-card-and-category`,

  bannerInfo: `${liveApiEndPoint}/services/provider/api/banner-info`,
  paymentStatus: `${liveApiEndPoint}/services/provider/api/payment-status`,
  cmsServiceSave: `${liveApiEndPoint}/services/admin/api/term-condition`,
  multiSelectPatientCat: `${liveApiEndPoint}/services/admin/api/categories-list-by-patient`,

  bundleCreate: `${liveApiEndPoint}/services/provider/api/bundle-create`,

  downloadFiles: `${liveApiEndPoint}/services/admin/api/patient-doc`,
  downloadCommentFile: `${liveApiEndPoint}/services/admin/api/download`,
  adminProviderToken: `${liveApiEndPoint}/services/admin/api/admin-provider-token`,

  // notes
  patientNotes: `${liveApiEndPoint}/services/dischargeplanner/api/patient-notes`,
  getStateList: `${liveApiEndPoint}/services/admin/api/state-list`,
  saveOrganizationDetail: `${liveApiEndPoint}/services/provider/api/organization`,

  // organization details by provider ID (for DP side panel - includes media base64)
  organizationDetailsByProviderId: `${liveApiEndPoint}/services/provider/api/organization`,

  // lazy per-org logo (provider search no longer inlines base64) — append /{providerId}/logo
  organizationLogoByProviderId: `${liveApiEndPoint}/services/provider/api/organization`,

  // organization media (logo, pictures, brochure)
  organizationLogoUpload: `${liveApiEndPoint}/services/provider/api/organization/logo`,
  organizationLogoDelete: `${liveApiEndPoint}/services/provider/api/organization/logo`,
  organizationPicturesUpload: `${liveApiEndPoint}/services/provider/api/organization/pictures`,
  organizationPicturesDelete: `${liveApiEndPoint}/services/provider/api/organization/pictures`,
  organizationBrochureUpload: `${liveApiEndPoint}/services/provider/api/organization/brochure`,
  organizationBrochureDelete: `${liveApiEndPoint}/services/provider/api/organization/brochure`,

  // reports
  downloadReport: `${liveApiEndPoint}/services/dischargeplanner/api/executive-summery`,
  downloadReportPdf: `${liveApiEndPoint}/services/dischargeplanner/api/executive-summery-pdf`,
  providerSignupLink: `${liveApiEndPoint}/services/dischargeplanner/api/provider-signup-link`,
  providersFromOtherNetwork: `${liveApiEndPoint}/services/dischargeplanner/api/out-network-provider-list`,
  sendLinkToOtherProviderDp: `${liveApiEndPoint}/services/dischargeplanner/api/send-link-to-add-dp-network`,
  acceptORDeclineInvitation: `${liveApiEndPoint}/services/provider/api/accept-declined-to-associat-facility`,
  fetchInvitationForProvider: `${liveApiEndPoint}/services/provider/api/fetch-facility-to-link`,

  //calendar APIs
  fetchCalendarData: `${liveApiEndPoint}/services/dischargeplanner/api/planner/calendar`,

  fetchPatientSearch: `${liveApiEndPoint}/services/dischargeplanner/api/patient/list`,

  // task templates
  postTasksTemplate: `${liveApiEndPoint}/services/dischargeplanner/api/patient-task-template`,
  getTaskTemplateByDP:`${liveApiEndPoint}/services/dischargeplanner/api/patient-task-template/dp`,
  getTaskTemplateByDPAll:`${liveApiEndPoint}/services/dischargeplanner/api/patient-task-template-all/dp`,
  getDefaultTaskTemplateByFacility: `${liveApiEndPoint}/services/dischargeplanner/api/patient-task-template/default`,
  checkTemplateApplied: `${liveApiEndPoint}/services/dischargeplanner/api/patient-task/template-applied`,
  getTaskTemplateByPT:`${liveApiEndPoint}/services/dischargeplanner/api/patient-task-template/patient`,
  getTaskTemplateById:`${liveApiEndPoint}/services/dischargeplanner/api/patient-task-template`,
  updateTaskTemplate:`${liveApiEndPoint}/services/dischargeplanner/api/patient-task-template`,
  deleteTaskTemplate:`${liveApiEndPoint}/services/dischargeplanner/api/patient-task-template`,
  TaskTemplatesBulk: `${liveApiEndPoint}/services/dischargeplanner/api/list-patient-task-template`,
  PatientTaskBulk: `${liveApiEndPoint}/services/dischargeplanner/api/bulk-patient-task`,
  deleteTaskTemplateEdit:`${liveApiEndPoint}/services/dischargeplanner/api/patient-task-template-delete`,
  TaskTemplatesBulk: `${liveApiEndPoint}/services/dischargeplanner/api/list-patient-task-template`,
  TaskTemplatesBulkEdit: `${liveApiEndPoint}/services/dischargeplanner/api/list-patient-task-template`,
  TaskTemplatesBulkUpdate: `${liveApiEndPoint}/services/dischargeplanner/api/list-patient-task-template`,
  StatusUpdate: `${liveApiEndPoint}/services/dischargeplanner/api/patient-task-template-status`,
  getPdfDownload:`${liveApiEndPoint}/services/dischargeplanner/api/task-list-pdf`,
  PatientTaskBulk:`${liveApiEndPoint}/services/dischargeplanner/api/bulk-patient-task`,
  GetGroupPatient: `${liveApiEndPoint}/services/dischargeplanner/api/group-patient-task/patient`,
  updateFaxFinalized: `${liveApiEndPoint}/services/dischargeplanner/api/update-fax-finalized`,

  //Survey Form 
  GetAllInputType: `${liveApiEndPoint}/services/dischargeplanner/api/sf/inputType/getAll`,
  PostSurveyForm: `${liveApiEndPoint}/services/dischargeplanner/api/sf/surveyForm/save`,
  PutSurveyForm: `${liveApiEndPoint}/services/dischargeplanner/api/sf/surveyForm/update/`,
  GetAllSurveyForm: `${liveApiEndPoint}/services/dischargeplanner/api/sf/surveyForm/getAll/`,
  GetAllSurveyFormDropDown: `${liveApiEndPoint}/services/dischargeplanner/api/sf/surveyForm/getAll/`,
  GetByIdSurveyForm: `${liveApiEndPoint}/services/dischargeplanner/api/sf/surveyForm/get/`,
  GetAllDomain: `${liveApiEndPoint}/services/dischargeplanner/api/sf/domain/getAll`,
  GetValidateSurveyForm: `${liveApiEndPoint}/services/dischargeplanner/api/sf/surveyForm/validate`,
  PreviewSurveyByTaskId: `${liveApiEndPoint}/services/dischargeplanner/api/sf/surveyForm/previewSurveyForm/`,
  GeneralPreviewSurvey: `${liveApiEndPoint}/services/dischargeplanner/api/sf/surveyForm/generalPreview`,
  AddPatientContact: `${liveApiEndPoint}/services/dischargeplanner/api/sf/patientContact/getByPatientId`,
  AddPatientContactSave: `${liveApiEndPoint}/services/dischargeplanner/api/sf/patientContact/save`,
  GetAllPatientContactList: `${liveApiEndPoint}/services/dischargeplanner/api/sf/patientContact/getAll`,
  GetPatientContactById: `${liveApiEndPoint}/services/dischargeplanner/api/sf/patientContact/getById`,
  UpdatePatientContact: `${liveApiEndPoint}/services/dischargeplanner/api/sf/patientContact/update`,

  // Patient Consumer APIs
  CreatePatientConsumer: `${liveApiEndPoint}/services/dischargeplanner/api/patient-consumer/create`,
  CreatePatientConsumerBulk: `${liveApiEndPoint}/services/dischargeplanner/api/patient-consumer/create-bulk`,
  DeactivatePatientConsumer: `${liveApiEndPoint}/services/dischargeplanner/api/patient-consumer`,
  ReactivatePatientConsumer: `${liveApiEndPoint}/services/dischargeplanner/api/patient-consumer`,
  GetPatientConsumers: `${liveApiEndPoint}/services/dischargeplanner/api/patient-consumer/by-patient`,

  GetAiSummary: `${liveApiEndPoint}/services/dischargeplanner/api/sf/formResponse/getAiSummary`,
  SyncAiRiskAnalysisStatus: `${liveApiEndPoint}/services/dischargeplanner/api/sf/surveyForm/syncAiStatus`,
  GetAllSurveyPatient: `${liveApiEndPoint}/services/dischargeplanner/api/sf/surveyForm/getAllPatients`,
  GetAllAssignee: `${liveApiEndPoint}/services/dischargeplanner/api/sf/surveyForm/getActiveDps`,
  GetAllSubmittedSurvey: `${liveApiEndPoint}/services/dischargeplanner/api/sf/formResponse/submit`,
  UpdateJustification: `${liveApiEndPoint}/services/dischargeplanner/api/sf/formResponse/updateJustification`,
  AddRiskStatusAndNotes: `${liveApiEndPoint}/services/dischargeplanner/api/sf/surveyForm/riskStatus`,

  // Referral Summary (DocuServe)
  GetReferralSummary: `${liveApiEndPoint}/services/dischargeplanner/api/referral-summary`,
  UpdateReferralSummary: `${liveApiEndPoint}/services/dischargeplanner/api/referral-summary`,
  DownloadReferralSummaryPdf: `${liveApiEndPoint}/services/dischargeplanner/api/referral-summary`,

  // External Patients (My Patients) APIs
  externalPatients: `${liveApiEndPoint}/services/provider/api/provider/external-patients`,
  externalPatientsManual: `${liveApiEndPoint}/services/provider/api/provider/external-patients/manual`,
  externalPatientsAiGenerated: `${liveApiEndPoint}/services/provider/api/provider/external-patients/ai-generated`,

};
